import { render, staticRenderFns } from "./common-icons.vue?vue&type=template&id=0b385255&scoped=true&"
import script from "./common-icons.vue?vue&type=script&lang=js&"
export * from "./common-icons.vue?vue&type=script&lang=js&"
import style0 from "./common-icons.vue?vue&type=style&index=0&id=0b385255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b385255",
  null
  
)

export default component.exports